import { createTypes } from '../../utils/helpers';

const HOURS_FETCH_ARRIVAL_HOURS: any = createTypes('HOURS_FETCH_ARRIVAL_HOURS');
const HOURS_FETCH_DAY_PART_HOURS: any = createTypes(
  'HOURS_FETCH_DAY_PART_HOURS',
);
const HOURS_SET_BASE_HOURS_OF_OPERATION: any = createTypes(
  'HOURS_SET_BASE_HOURS_OF_OPERATION',
);
const HOURS_FETCH_BASE_HOURS_OF_OPERATION: any = createTypes(
  'HOURS_FETCH_BASE_HOURS_OF_OPERATION',
);
const HOURS_SEND_HOLIDAYS_OFF: any = createTypes('HOURS_SEND_HOLIDAYS_OFF');
const SPECIAL_EVENTS_OFF: any = createTypes('SPECIAL_EVENTS_OFF');
const HOURS_FETCH_ROUTINE_HOURS: any = createTypes('HOURS_FETCH_ROUTINE_HOURS');
const HOURS_SET_DAY_PART_HOURS: any = createTypes('HOURS_SET_DAY_PART_HOURS');
const HOURS_SET_ROUTINE_HOURS: any = createTypes('HOURS_SET_ROUTINE_HOURS');
const FETCH_SPECIAL_EVENT_REASONS: any = createTypes(
  'FETCH_SPECIAL_EVENT_REASONS',
);
const HOURS_SET_BASE_OPERATION_HOURS_MODIFICATION =
  'HOURS_SET_BASE_OPERATION_HOURS_MODIFICATION';
const HOURS_SET_OPERATION_HOUR = 'HOURS_SET_OPERATION_HOUR';
const HOURS_SET_OPERATION_HOUR_WEEKDAYS = 'HOURS_SET_OPERATION_HOUR_WEEKDAYS';
const HOURS_SET_EDITED = 'HOURS_SET_EDITED';
const HOURS_CLEAR_ALL = 'HOURS_CLEAR_ALL';
const SET_BASE_OPERATION_HOUR_PERMISSION = 'SET_BASE_OPERATION_HOUR_PERMISSION';
const FETCH_DELIVERY_HOURS: any = createTypes('FETCH_DELIVERY_HOURS');

export {
  HOURS_FETCH_ARRIVAL_HOURS,
  HOURS_FETCH_DAY_PART_HOURS,
  HOURS_SET_BASE_HOURS_OF_OPERATION,
  HOURS_FETCH_BASE_HOURS_OF_OPERATION,
  HOURS_SEND_HOLIDAYS_OFF,
  SPECIAL_EVENTS_OFF,
  HOURS_FETCH_ROUTINE_HOURS,
  HOURS_SET_DAY_PART_HOURS,
  HOURS_SET_ROUTINE_HOURS,
  HOURS_SET_OPERATION_HOUR,
  HOURS_SET_OPERATION_HOUR_WEEKDAYS,
  HOURS_SET_EDITED,
  HOURS_CLEAR_ALL,
  HOURS_SET_BASE_OPERATION_HOURS_MODIFICATION,
  FETCH_SPECIAL_EVENT_REASONS,
  FETCH_DELIVERY_HOURS,
  SET_BASE_OPERATION_HOUR_PERMISSION,
};
